import React from 'react'
import styles from '../styles.css'

type PropsType = {
  renderKey: string
  colors: any
  active: boolean
  setSection: (i: number) => void
  index: number
}

export const CategoryTag = (props: PropsType) => {
  const renderKey = props.renderKey
  const active = props.active
  const setSection = props.setSection
  const index = props.index

  const accentColor = props.colors?.accent ? props.colors.accent : '#45b0f5'
  const textColor = props.colors?.text ? props.colors.text : '#333'

  const color = active ? accentColor : textColor

  return (
    <b
      key={renderKey}
      style={{
        color: color,
        border: 'solid 1px ' + color,
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 2,
        paddingBottom: 2,
        borderRadius: 100
      }}
      className={styles.activeSection}
      onClick={() => setSection(index)}
    >
      {renderKey}
    </b>
  )
}
